import React, { Component } from "react";
import { PDFObject } from "react-pdfobject";
import { env, ENV } from "../../common/sysco-ui-components/config/constant";
import  cookie from "react-cookies";
import history from "../../utils/history";
import { getToken } from "../../config/apiConfig";
import { connect } from "react-redux";
import Axios from "axios";
import { VERIFY_SESSION_PATH } from "../../config/path";

class User_Guide extends Component {
  static displayName = 'User_Guide';
  constructor(props) {
    super(props);
    this.state = {
      url:`https://les${env()}.sysco.com/otcs/cs.exe/api/v1/nodes/${
        ENV()==='-dev'?"13094262":ENV()==='-stg'?'25420815':ENV()==='-prod'?'117621503':''
        }/content?OTDSTicket=${cookie.load("serviceToken")}`
    };
  }

  async componentDidMount() {
    try {
      const authCheck = await Axios.get(VERIFY_SESSION_PATH);
      if (!authCheck.data.authenticated) {
        history.push("/");
        return;
      }

      let data = await getToken();
      this.setState({
        url: `https://les${env()}.sysco.com/otcs/cs.exe/api/v1/nodes/${ENV() === '-dev' ? "13094262" :
          ENV() === '-stg' ? '25420815' : ENV() === '-prod' ? '117621503' : ''
          }/content?OTDSTicket=${data ? data : cookie.load("serviceToken")}`
      });
    } catch (error) {
      console.error("Authentication check failed:", error);
      history.push("/");
    }
  }
  
  
  render() {
    return <div style={{height:"86Vh"}}><PDFObject containerId='userGuide' height="90Vh"  url={this.state.url} /></div>;
  }
}

export default connect()(User_Guide);
